import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { site } from "@/data/site";
import { getLenis } from "@/lib/lenis";
import Magnetic from "@/components/Magnetic";

export default function Footer() {
    const [time, setTime] = useState("");

    useEffect(() => {
        const tick = () =>
            setTime(
                new Date().toLocaleTimeString("de-DE", {
                    timeZone: "Europe/Berlin",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                })
            );
        tick();
        const i = setInterval(tick, 1000);
        return () => clearInterval(i);
    }, []);

    const toTop = () => {
        const lenis = getLenis();
        if (lenis) lenis.scrollTo(0, { duration: 1.6 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer data-testid="site-footer" className="border-t border-white/10">
            <div className="mx-auto max-w-[1600px] px-5 pb-10 pt-20 sm:px-10">
                <div className="flex items-start justify-between gap-8">
                    <p
                        data-testid="footer-brand"
                        className="text-stroke font-display text-[11vw] font-extrabold uppercase leading-[0.85] tracking-tighter sm:text-[12vw]"
                        aria-label={site.studioName}
                    >
                        BVISION
                    </p>
                    <Magnetic>
                        <button
                            data-testid="footer-back-to-top"
                            data-cursor="link"
                            onClick={toTop}
                            aria-label="Nach oben scrollen"
                            className="mt-4 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-white/20 text-[#F4F4F0] transition-colors duration-300 hover:border-[#E63946] hover:bg-[#E63946]"
                        >
                            <ArrowUp size={18} />
                        </button>
                    </Magnetic>
                </div>

                <div className="mt-14 grid grid-cols-2 gap-8 border-t border-white/10 pt-8 sm:grid-cols-4">
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">Studio</p>
                        <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-[#F4F4F0]">
                            BVISION Designer Studio
                        </p>
                    </div>
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">Social</p>
                        <div className="mt-3 flex flex-col gap-2">
                            {site.socials.map((s) => (
                                <a
                                    key={s.label}
                                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                                    data-cursor="link"
                                    href={s.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-sm text-[#F4F4F0]/80 transition-colors duration-300 hover:text-[#E63946]"
                                >
                                    {s.label}
                                </a>
                            ))}
                            <a
                                data-testid="footer-email"
                                data-cursor="link"
                                href={`mailto:${site.email}`}
                                className="text-sm text-[#F4F4F0]/80 transition-colors duration-300 hover:text-[#E63946]"
                            >
                                E-Mail
                            </a>
                        </div>
                    </div>
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">Rechtliches</p>
                        <div className="mt-3 flex flex-col gap-2">
                            <Link data-testid="footer-impressum-link" data-cursor="link" to="/impressum" className="text-sm text-[#F4F4F0]/80 transition-colors duration-300 hover:text-[#E63946]">
                                Impressum
                            </Link>
                            <Link data-testid="footer-datenschutz-link" data-cursor="link" to="/datenschutz" className="text-sm text-[#F4F4F0]/80 transition-colors duration-300 hover:text-[#E63946]">
                                Datenschutz
                            </Link>
                        </div>
                    </div>
                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">Wuppertal, DE</p>
                        <p data-testid="footer-clock" className="mt-3 font-mono text-sm text-[#F4F4F0]">
                            {time} CET
                        </p>
                    </div>
                </div>

                <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#A1A1AA]">
                        © {new Date().getFullYear()} BVISION Designer Studio
                    </p>
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#A1A1AA]">
                        Ideen werden Visuals.
                    </p>
                </div>
            </div>
        </footer>
    );
}
